import { CompanyType } from 'shame/enums';

export const companyTypeList = [
  {value: CompanyType.PUBLIC, label: 'Public'},
  {value: CompanyType.PRIVATE, label: 'Private'}
]
